import { getPaymentFields } from '../../constants';
import { SectionProps } from '../../types';
import { FormSection } from './FormSection';

export const PaymentCategories = ({ accountingEnvironment, options }: SectionProps) => (
    <FormSection
        items={getPaymentFields({ showTaxDeductedPayment: !!accountingEnvironment.allowTaxDeductedPayments })}
        prefix="genericPayments"
        options={options}
    />
);
